<svg style="display: none" aria-hidden="true">
  <defs>
    <filter id="filter-deuteranopia">
      <feColorMatrix
        type="matrix"
        values="0.625 0.375 0 0 0  0.7 0.3 0 0 0  0 0.3 0.7 0 0  0 0 0 1 0"
      />
    </filter>
    <filter id="filter-tritanopia">
      <feColorMatrix
        type="matrix"
        values="0.95 0.05 0 0 0  0 0.433 0.567 0 0  0 0.475 0.525 0 0  0 0 0 1 0"
      />
    </filter>
  </defs>
</svg>

<div
  class="ada-widget"
  [class.ada-widget--right]="alignRight"
  role="region"
  aria-label="Accessibility settings"
>
  @if (isOpen) {
    <div
      class="ada-panel"
      [@expandUp]
      role="dialog"
      aria-modal="true"
      aria-label="Accessibility options panel"
    >
      <div class="ada-header">
        <mat-icon class="ada-header-icon" aria-hidden="true">accessibility_new</mat-icon>
        <span class="ada-header-title">Accessibility</span>
      </div>

      <mat-divider aria-hidden="true"></mat-divider>

      <div class="ada-section-label" aria-hidden="true">Visual</div>

      <div class="ada-row">
        <div class="ada-row-info">
          <span class="ada-row-label">High contrast</span>
          <span class="ada-row-desc">Increases color contrast</span>
        </div>
        <mat-slide-toggle
          [(ngModel)]="a11y.highContrast"
          (change)="toggle('highContrast')"
          aria-label="Toggle high contrast"
          color="primary"
        >
        </mat-slide-toggle>
      </div>

      <div class="ada-row">
        <div class="ada-row-info">
          <span class="ada-row-label">Large text</span>
          <span class="ada-row-desc">Increases font size by 20%</span>
        </div>
        <mat-slide-toggle
          [(ngModel)]="a11y.largeText"
          (change)="toggle('largeText')"
          aria-label="Toggle large text"
          color="primary"
        >
        </mat-slide-toggle>
      </div>

      <mat-divider aria-hidden="true"></mat-divider>

      <div class="ada-section-label" aria-hidden="true">Reading</div>

      <div class="ada-row">
        <div class="ada-row-info">
          <span class="ada-row-label">Dyslexia-friendly font</span>
          <span class="ada-row-desc">Switches to OpenDyslexic</span>
        </div>
        <mat-slide-toggle
          [(ngModel)]="a11y.dyslexiaFont"
          (change)="toggle('dyslexiaFont')"
          aria-label="Toggle dyslexia font"
          color="primary"
        >
        </mat-slide-toggle>
      </div>

      <div class="ada-row">
        <div class="ada-row-info">
          <span class="ada-row-label">Reduce motion</span>
          <span class="ada-row-desc">Disables animations</span>
        </div>
        <mat-slide-toggle
          [(ngModel)]="a11y.reduceMotion"
          (change)="toggle('reduceMotion')"
          aria-label="Toggle reduce motion"
          color="primary"
        >
        </mat-slide-toggle>
      </div>

      <mat-divider aria-hidden="true"></mat-divider>

      <div class="ada-section-label" aria-hidden="true">Color vision</div>

      <div class="ada-select-row">
        <mat-form-field appearance="outline" class="ada-select">
          <mat-label>Color blind mode</mat-label>
          <mat-select
            [(ngModel)]="a11y.colorBlindMode"
            (selectionChange)="onColorBlindChange()"
            aria-label="Select color blind mode"
          >
            @for (opt of colorBlindOptions; track opt.value) {
              <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  }

  <button
    class="ada-fab"
    [class.ada-fab--active]="anyActive"
    (click)="toggleOpen()"
    [attr.aria-expanded]="isOpen"
    aria-label="Toggle accessibility options"
    matTooltip="Accessibility"
    matTooltipPosition="left"
  >
    <mat-icon aria-hidden="true">accessibility_new</mat-icon>
  </button>
</div>
